module.exports = {
  saveForLater: 'Save & Come Back Later',
  saveApplication: 'Save Application',
  continue: 'Continue',
  back: 'Back',
  yes: 'Yes',
  no: 'No',
  close: 'Close',
  select: 'Select',
  selected: 'Selected',
  applicationLoading: 'Retrieving Application',
  savingApplication: 'Saving Application',
  savingFamilyApplication: 'Applications are being saved. This may take a few seconds. Do not close your browser.',
  insured: 'Policyholder',
  insureAnotherPerson: 'Insure Another Person',
  slovakRepublic: 'Slovak Republic',
  slovakia: 'Slovakia',
  abroad: 'Third Country',
  addAnotherPerson: 'Add Another Person',
  unionInformation: 'Insurance Provider Information',
  gdpr: 'Personal Data Protection',
  notAvailable: 'Sorry, the service is currently unavailable.',
  notFoundParagraph1: 'We\'re sorry, but the page you were looking for could not be found.',
  notFoundParagraph2: 'The page has been deleted, moved or renamed.',
  notFoundParagraph3: 'What can you do now?',
  notFoundListItem1: 'if you have entered the address manually in your browser, you can check it for typos',
  notFoundListItem2: 'if you have copied & pasted the address, you can check if you have copied the whole address',
  notFoundListItem3: 'if you have entered the address correctly or clicked on a link on the website,',
  contactUs: 'Contact Us',
  day: 'Day',
  month: 'Month',
  year: 'Year',
  remove: 'Delete',
  customerCentre: 'Customer Centre',
  mondayFriday: 'Mon-Fri',
  usefulLinks: 'Useful Links',
  cookiesSettings: 'Cookies Settings',
  aboutUs: 'About Us',
  optional: 'Optional',
  edit: 'Edit',
  otherAddress: 'Different Address',
};
